export { Bombero } from './bombero'
export { Correo } from './correo'
export { Police } from './police'
export { Administrativo } from './administrativo'
export { Memoria } from './memoria'
export { Ninja } from './ninja'
